import React from "react";
import { useSelector } from "react-redux";
import { stackedBarPairedPalette } from "../colors";
import D3StackedBar from "./D3StackedBar";
import RccCard from "../RccCard";
import { useWonAcvDealCategoryData } from "../hooks/useWonAcvData";

function WonACVByDealCategoryCard({ title, redirectToDashboard }) {
  const user = useSelector((state) => state.app.user || {});
  const Value_Label = useSelector((state) => state.app.user.Value_Label);
  const { chartData, derivedCategories, appliedFilters, isLoading } =
    useWonAcvDealCategoryData();

  return (
    <RccCard
      title={title || `Won ${Value_Label} by Deal Category`}
      isLoading={isLoading}
      redirectToDashboard={redirectToDashboard || `Won ${Value_Label} Mix Analysis`}
      appliedFilters={appliedFilters}
      focusVariant={"current"}
    >
      <D3StackedBar
        data={chartData}
        categories={derivedCategories}
        colorPalette={stackedBarPairedPalette}
        currencySymbol={user?.Currency}
        options={{ showLabels: true, showLegend: true }}
      />
    </RccCard>
  );
}

export default WonACVByDealCategoryCard;
